// extracted by mini-css-extract-plugin
export default {"container":"Faq_container__S60lk","questions":"Faq_questions__rC6Ge"};